export class ReconnectSourceAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "SourceAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectSourceAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
